<div class="mt-6 flex flex-col md:flex-row md:items-start gap-6">
  <div
    [ngClass]="{
      'w-full': true,
      'md:w-1/2': establishment?.establishmentType === EstablishmentTypeEnum.SUPPORT_FUNCTION
    }"
  >
    <div
      id="establishment-resume-details-card"
      class="card"
      *ngIf="establishmentService.entity$ | async as establishment"
    >
      <div class="px-gutter py-4 border-b" fxLayout="row" fxLayoutAlign="space-between center">
        <h2 class="title m-0">Détails</h2>
        <!-- TODO PERMISSION <button color='primary' mat-raised-button type='button' *hasPermission="[ENUM_PERMISSIONS.UPDATE_CP_ESTABLISHMENT_INFO]" (click)='updateItem()'>MODIFIER</button>-->
        <button color="primary" mat-raised-button type="button" (click)="updateItem()" *ngIf="canUpdatePermission">
          MODIFIER
        </button>
      </div>
      <div
        *ngIf="establishment._id; else loading"
        class="px-gutter py-4"
        gdColumns="1fr 1fr"
        gdColumns.xs="1fr"
        gdGap="16px"
      >
        <details-line-base hint="Identifiant Technique" [label]="establishment.technicalIdentifier"></details-line-base>

        <details-line-base hint="Libellé" [label]="establishment.label | titlecase"></details-line-base>

        <details-line-base hint="Identifiant logiciel comptable" [label]="establishment.accountingSoftwareId"></details-line-base>

        <details-line-base
          *ngIf="establishment.sirenNumber"
          hint="N° Siren"
          [label]="establishment.sirenNumber"
        ></details-line-base>

        <details-line-base
          *ngIf="establishment.siretNumber"
          hint="N° Siret"
          [label]="establishment.siretNumber"
        ></details-line-base>

        <details-line-base
          *ngIf="establishment.dunsNumber"
          hint="Identifiant entreprise"
          [label]="establishment.dunsNumber"
        ></details-line-base>

        <details-line-base hint="Numéro TVA" [label]="establishment.tva"></details-line-base>

        <details-line-base hint="Code APE" [label]="establishment.ape"></details-line-base>

        <details-line-base
          hint="Comptable de rattachement"
          [label]="
            establishment.attachedAccountant
              ? establishment.attachedAccountant.firstName + ' ' + establishment.attachedAccountant.lastName
              : 'N/A'
          "
        ></details-line-base>

        <details-line-base hint="Plan comptable" [label]="establishment.accountChart?.label"></details-line-base>

        <details-line-base
          *ngIf="
            establishment?.establishmentType === EstablishmentTypeEnum.SUPPORT_FUNCTION &&
            establishment?.mainEstablishmentData
          "
          hint="Etablissement principal"
          [label]="establishment.mainEstablishmentData?.label"
          [linkPermission]="ENUM_PERMISSIONS.READ_ESTABLISHMENT"
          [link]="'/management/establishment/' + establishment.mainEstablishmentData?._id"
        ></details-line-base>

        <!-- Boutons de gestion de l'établissement principal -->
        <div
          *ngIf="establishment?.establishmentType === EstablishmentTypeEnum.SUPPORT_FUNCTION && canUpdatePermission"
          class="flex justify-end mt-4 mb-2"
        >
          <!-- Bouton Ajouter si pas d'établissement principal -->
          <button
            *ngIf="!establishment?.mainEstablishmentId"
            mat-stroked-button
            color="primary"
            type="button"
            (click)="updateMainEstablishment()"
            class="text-sm"
          >
            <mat-icon class="mr-2">add</mat-icon>
            Ajouter un établissement principal
          </button>

          <!-- Bouton Modifier si établissement principal existe -->
          <button
            *ngIf="establishment?.mainEstablishmentId"
            mat-stroked-button
            color="primary"
            type="button"
            (click)="updateMainEstablishment()"
            class="text-sm"
          >
            <mat-icon class="mr-2">swap_horiz</mat-icon>
            Modifier l'établissement principal
          </button>
        </div>

        <!--                <details-line-base-->
        <!--                        hint="Capacité budgétaire"-->
        <!--                        [label]="translateValidatorMatriceLevel"-->
        <!--                >-->
        <!--                </details-line-base>-->

        <details-line-base
          hint="Statut TVA"
          [label]="establishment.vatStatus ? 'Soumis' : 'Non soumis'"
        ></details-line-base>
        <ng-container *ngIf="establishment?.internSupplier && this.isCurrentUserPredik">
          <details-line-base
            hint="Fournisseur interne lié"
            [label]="establishment.internSupplier.label"
            [link]="'/management/supplier/' + establishment?.internSupplier?._id"
          ></details-line-base>
        </ng-container>
      </div>
      <div class="px-gutter py-4 border-b" fxLayout="row" fxLayoutAlign="space-between center">
        <h2 class="title m-0">Coordonnées</h2>
      </div>
      <div class="px-gutter py-4">
        <!-- Téléphone (toujours affiché) -->

        <details-line-base
          hint="Téléphone (Standard)"
          [label]="establishment.phoneNumber?.displayPhoneNumber"
        ></details-line-base>

        <!-- Adresse principale -->
        <details-line-base
          *ngIf="establishment?.mainAddressData"
          hint="Adresse administrative"
          [label]="establishment?.mainAddressData | formatAddress"
        ></details-line-base>

        <!-- Message informatif en cas d'absence d'adresse principale -->
        <div *ngIf="!establishment.mainAddressData" class="text-center bg-gray-50 rounded-lg p-4">
          <p class="text-sm text-gray-500 m-0">Aucune adresse administrative configurée</p>
        </div>
      </div>

      <!-- Section Facturation -->
      <div class="px-gutter py-4 border-b" fxLayout="row" fxLayoutAlign="space-between center">
        <h2 class="title m-0">Facturation</h2>
      </div>
      <div class="px-gutter py-4">
        <!-- Adresse de facturation (adresse postale) -->
        <details-line-base
          *ngIf="establishment?.billingAddressData"
          hint="Envoi de facture"
          [label]="establishment?.billingAddressData | formatAddress"
        ></details-line-base>

        <!-- Email de facturation -->
        <details-line-base
          *ngIf="establishment?.billingEmail"
          hint="Email de facturation"
          [label]="establishment.billingEmail"
        ></details-line-base>

        <!-- Message si aucune adresse/email de facturation -->
        <div
          *ngIf="!establishment?.billingAddressData && !establishment?.billingEmail"
          class="text-center bg-gray-50 rounded-lg p-4 mb-2"
        >
          <p class="text-sm text-gray-500 m-0">Aucune adresse de facturation configurée</p>
        </div>

        <!-- Mode de règlement -->
        <details-line-base
          *ngIf="establishment?.paymentMethod"
          hint="Mode de règlement"
          [label]="establishment.paymentMethod.label"
        ></details-line-base>

        <!-- BIC / IBAN côte à côte -->
        <div
          *ngIf="establishment?.paymentMethod?.requiresBankDetails"
          gdColumns="1fr 1fr"
          gdColumns.xs="1fr"
          gdGap="16px"
        >
          <details-line-base
            *ngIf="establishment.paymentMethod.bic"
            hint="BIC"
            [label]="establishment.paymentMethod.bic"
          ></details-line-base>

          <details-line-base
            *ngIf="establishment.paymentMethod.iban"
            hint="IBAN"
            [label]="establishment.paymentMethod.iban"
          ></details-line-base>
        </div>
      </div>
    </div>
  </div>

  <div class="w-full md:w-1/2 flex-none">
    <vex-establishment-details-addresses></vex-establishment-details-addresses>

    <div *ngIf="establishment?.establishmentType === EstablishmentTypeEnum.SUPPORT_FUNCTION" class="w-full flex-none">
      <div
        *ngIf="
          establishment?.establishmentType && establishment.establishmentType === EstablishmentTypeEnum.SUPPORT_FUNCTION
        "
        class="card"
      >
        <div class="px-gutter py-4 border-b" fxLayout="row" fxLayoutAlign="space-between center">
          <h2 class="title m-0">Charges annuelles</h2>
          <button
            color="primary"
            mat-raised-button
            type="button"
            [permissionBlock]="[ENUM_PERMISSIONS.UPDATE_ESTABLISHMENT]"
            (click)="updateAnnualCharge()"
          >
            AJOUTER
          </button>
        </div>
        <div class="px-gutter py-4">
          <base-data-table
            [dataSource]="dataSourceAnnualCharges"
            [displayedColumns]="displayedColumnsAnnualCharges"
            [feisColumns]="feisColumnsAnnualCharges"
            (onUpdateItem)="updateAnnualCharge($event)"
          ></base-data-table>
        </div>
      </div>

      <div
        *ngIf="
          establishment?.establishmentType && establishment.establishmentType === EstablishmentTypeEnum.SUPPORT_FUNCTION
        "
        id="establishment-resume-clients-card"
        class="card mt-6"
      >
        <div class="px-gutter py-4 border-b" fxLayout="row" fxLayoutAlign="space-between center">
          <h2 class="title m-0">Etablissements Clients</h2>
          <div>
            <button
              color="primary"
              mat-raised-button
              type="button"
              [permissionBlock]="[ENUM_PERMISSIONS.UPDATE_ESTABLISHMENT]"
              (click)="addEstablishmentCustomer()"
            >
              AJOUTER
            </button>
          </div>
        </div>

        <div @stagger class="px-gutter py-4 establishment-clients-table" gdGap="24px">
          <base-data-table
            [count]="countEstablishmentCustomers"
            [pageSize]="pageSizeEstablishmentCustomers"
            [sortField]="sortFielEstablishmentCustomers"
            [sortOrder]="sortOrderEstablishmentCustomers"
            [dataSource]="dataSourceEstablishmentCustomers"
            [feisColumns]="feisColumnsEstablishmentCustomers"
            [allowTextWrap]="true"
            (onDeleteItem)="deleteEstablishmentCustomers($event)"
          ></base-data-table>
        </div>
      </div>
    </div>

    <ng-template #loading>
      <div class="px-gutter py-4" gdColumns="1fr 1fr" gdColumns.xs="1fr" gdGap="16px">
        <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
          <vex-skeleton class="w-14 mr-2" heigthTailwind="h-12" [circle]="true"></vex-skeleton>
          <vex-skeleton class="w-full" heigthTailwind="h-12"></vex-skeleton>
        </div>

        <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
          <vex-skeleton class="w-14 mr-2" heigthTailwind="h-12" [circle]="true"></vex-skeleton>
          <vex-skeleton class="w-full" heigthTailwind="h-12"></vex-skeleton>
        </div>

        <div class="py-3" fxLayout="row" fxLayoutAlign="start center">
          <vex-skeleton class="w-14 mr-2" heigthTailwind="h-12" [circle]="true"></vex-skeleton>
          <vex-skeleton class="w-full" heigthTailwind="h-12"></vex-skeleton>
        </div>
      </div>
    </ng-template>
  </div>
</div>
